import { useContext, useEffect } from "react";
import { UserContext } from "../../../context/userContext";
import { Button } from "../../../components/Button";

const NotFoundPage: React.FC = () => {
    useEffect(() => {
        document.title = "Page Not Found."
    }, []);

    return (
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
            <div className="text-center">
                <p className="text-base font-semibold text-zinc-600">Error 404</p>
                <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
                <p className="mt-6 text-base leading-7 text-gray-600">Sorry, we couldn’t find the page you’re looking for.</p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <Button href="/gp/dashboard">
                        Go back Dashboard
                    </Button>
                    {/* <a href="#" className="text-sm font-semibold text-gray-900">
                        Contact support <span aria-hidden="true">&rarr;</span>
                    </a> */}
                </div>
            </div>
        </main>
    );
}

export default NotFoundPage;